<template>
  <div>
    <el-breadcrumb separator-icon="ArrowRight" style="margin: 16px" class="hide-mobile">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>我的宿舍</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="myroom-card">
      <div class="myroom-page">
        <!-- 房间信息 -->
        <div class="myroom-section">
          <div class="myroom-section-title">
            <el-icon><House /></el-icon> 房间信息
          </div>
          <div class="myroom-info-grid">
            <div class="myroom-info-item">
              <span class="myroom-info-label">楼宇号</span>
              <span class="myroom-info-value">{{ room.dormBuildId }}</span>
            </div>
            <div class="myroom-info-item">
              <span class="myroom-info-label">房间号</span>
              <span class="myroom-info-value">{{ room.dormRoomId }}</span>
            </div>
            <div class="myroom-info-item">
              <span class="myroom-info-label">楼层</span>
              <span class="myroom-info-value">{{ room.floorNum }}</span>
            </div>
            <div class="myroom-info-item">
              <span class="myroom-info-label">可住/已住</span>
              <span class="myroom-info-value">{{ room.currentCapacity }}/{{ room.maxCapacity }}</span>
            </div>
          </div>
        </div>
        <!-- 床位信息 -->
        <div class="myroom-section">
          <div class="myroom-section-title">
            <el-icon><User /></el-icon> 床位信息
          </div>
          <div class="myroom-bed-list">
            <div v-for="(bed, idx) in beds" :key="idx" class="myroom-bed-item" :class="{ 'my-bed': bed.name === name }">
              <span class="myroom-bed-num">{{ idx + 1 }}号床</span>
              <span class="myroom-bed-name">
                <el-tag v-if="bed.name" :type="bed.name === name ? 'primary' : 'info'" size="small">{{ bed.name }}</el-tag>
                <span v-else class="bed-empty">空床</span>
              </span>
              <el-tag v-if="bed.name === name" type="success" size="small" effect="plain">我</el-tag>
            </div>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>
<script src="@/assets/js/MyRoomInfo.js"></script>
<style scoped>
.myroom-card { margin: 12px; }
.myroom-page { display: flex; gap: 24px; flex-wrap: wrap; }
.myroom-section { flex: 1; min-width: 280px; }
.myroom-section-title {
  display: flex; align-items: center; gap: 6px;
  font-size: 16px; font-weight: 600; color: #303133;
  margin-bottom: 16px; padding-bottom: 8px;
  border-bottom: 2px solid #00ab84;
}
.myroom-section-title .el-icon { color: #00ab84; }

.myroom-info-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 12px; }
.myroom-info-item {
  background: #f7f8fa; border-radius: 8px; padding: 12px;
  display: flex; flex-direction: column; gap: 4px;
}
.myroom-info-label { font-size: 12px; color: #909399; }
.myroom-info-value { font-size: 18px; font-weight: 600; color: #303133; }

.myroom-bed-list { display: flex; flex-direction: column; gap: 8px; }
.myroom-bed-item {
  display: flex; align-items: center; gap: 10px;
  padding: 10px 14px; background: #f7f8fa; border-radius: 8px;
  border-left: 3px solid #dcdfe6;
}
.myroom-bed-item.my-bed { border-left-color: #00ab84; background: #f0faf7; }
.myroom-bed-num { font-size: 13px; color: #909399; width: 50px; }
.myroom-bed-name { flex: 1; }
.bed-empty { color: #c0c4cc; font-size: 13px; }

@media screen and (max-width: 768px) {
  .myroom-card { margin: 8px; }
  .myroom-page { flex-direction: column; gap: 16px; }
  .myroom-section { min-width: auto; }
  .myroom-info-grid { grid-template-columns: repeat(2, 1fr); gap: 8px; }
  .myroom-info-value { font-size: 16px; }
}
.hide-mobile { display: none; }
@media screen and (min-width: 769px) { .hide-mobile { display: block; } }
</style>
